import { View, ScrollView, StyleSheet } from 'react-native';
import { Text, theme } from '@socrait/react';

import { Select } from '~/components/Select';
import { Tooltip } from '~/components/Tooltip';
import { type IncludeKey, type Timeframe } from '~/services/studentData';
import { type IncludeOptions } from '~/store/studentData/studentDataStore';
import { useUserProfile } from '~/services/useUserProfileQuery';

import { IncludeCheckboxes } from './IncludeCheckboxes';
import { TIMEFRAME_OPTIONS, SPARK_RESTRICTED_TIMEFRAMES } from './sharedFilters';
import { filterPanelStyles } from './sharedStyles';
import { SparkTooltipContent } from './sparkTooltipContent';

type DataLogFilterPanelProps = {
  include: IncludeOptions;
  timeframe: Timeframe;
  onIncludeChange: (key: IncludeKey, checked: boolean) => void;
  onTimeframeChange: (t: Timeframe) => void;
};

export function DataLogFilterPanel({
  include,
  timeframe,
  onIncludeChange,
  onTimeframeChange,
}: DataLogFilterPanelProps) {
  const { user } = useUserProfile();
  const isSpark = user?.isSpark ?? false;

  return (
    <ScrollView style={filterPanelStyles.scrollView}>
      <View style={filterPanelStyles.container}>
        <View style={filterPanelStyles.section}>
          <Text style={filterPanelStyles.sectionLabel}>Show entries for:</Text>
          <IncludeCheckboxes include={include} onChange={onIncludeChange} />
        </View>

        <View style={filterPanelStyles.section}>
          <Text style={filterPanelStyles.sectionLabel}>Time range:</Text>
          <View style={filterPanelStyles.sectionContent}>
            <View style={styles.selectRow}>
              <View style={styles.selectContainer}>
                <Select
                  value={timeframe}
                  onChange={(value) => onTimeframeChange(value as Timeframe)}
                  options={TIMEFRAME_OPTIONS}
                  disabledValues={isSpark ? SPARK_RESTRICTED_TIMEFRAMES : undefined}
                />
              </View>
              {isSpark && <Tooltip tooltipContent={<SparkTooltipContent />} />}
            </View>
          </View>
        </View>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  selectRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing.small,
    overflow: 'visible',
  },
  selectContainer: {
    width: '90%',
  },
});
